const userAgent = window.navigator.userAgent;
const ua = userAgent.toLowerCase();
const platform = {
  isAndroid: function () {
    return ua.indexOf('android') > -1;
  },
  isIOS: function () {
    return ua.indexOf('iphone') > -1;
  },
  isWinPhone: function () {
    return !!navigator.userAgent.match(/Windows Phone/i);
  },
  isIpad: function () {
    let NPlatform = navigator.platform;
    return (
      /iPad/gi.test(NPlatform) ||
      (NPlatform === 'MacIntel' &&
        navigator.maxTouchPoints > 1 &&
        !window.MSStream)
    );
  },
  isPhone: function () {
    return (
      this.isAndroid() || this.isIOS() || this.isWinPhone() || this.isIpad()
    );
  },
  isIE11: function () {
    return (
      userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
    );
  },
  isEdge: function () {
    return userAgent.indexOf('Edge') > -1;
  },
};

export const whatDevice = () => {
  if (!platform.isPhone() || platform.isIE11() || platform.isEdge()) {
    return 'pc';
  }
  if (platform.isPhone()) {
    return 'mobile';
  }
};

export const deviceType = () => {
  if (platform.isIOS() || platform.isIpad()) {
    return 'ios';
  }
  if (platform.isAndroid()) {
    return 'android';
  }
};

export const getParam = name => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = window.location.search.slice(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
};